import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  selected: css`
    && {
      background-color: ${cssTheme.default.day.backgroundInvert};
    }
  `,
}
